<div class="form-group" [formGroup]="group" [hidden]="this.isHidden">
  <label class="question-label" [ngClass]="{'bold': boldLabel, 'more-padding' : largeButtons, 'amber-label': customClass === 'amber-label' }" [attr.for]="identifier"
    *ngIf="label">{{ label }} <span *ngIf="requiredIndicator" class="text-danger"> *</span></label>
  <label class="question-label d-block" [ngClass]="{'more-padding' : largeButtons }" *ngIf="explanation">{{ explanation
    }}</label>
  <div [attr.id]="identifier" class="btn-group-toggle" ngbRadioGroup>
    <label ngbButtonLabel class="btn list-button" *ngFor="let option of options; let i = index" [ngClass]="{
           'invalid': markInvalid,
           'btn-block': vertical,
           'vertical': vertical,
           'informed-answer': option.key === informedAnswer,
           'default-answer': getDefaultHighlight(option.key),
           'no-text' : getOptionIcon(option.value) !== '',
           'more-options' : options.length > 4,
      'last' : i === options.length - 1,
      'active' : group.value.value === option.key && !(option.key === '1' && disableOption),
      'readonly': readOnly || option.key === '1' && disableOption,
      'small-two-line' : customClass === 'small-two-line',
      'extra-large' : largeButtons,
      'me-4': largeButtons,
      'isDisabled': option.key === '1' && disableOption
      }">
      <input formControlName="value" type="radio" [value]="option.key" (blur)="checkValid()"
        (focus)="removeInvalidMark()" (change)="valueChanged()" [disabled]="disabled || !isOptionEnabled(option.value)">
      <span *ngIf="optionIcon === ''" [innerHTML]="option.value"></span>
      <img *ngIf="optionIcon !== ''" [ngClass]="optionIcon" alt="Option-Icon">
    </label>
  </div>
</div>